import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {NavBar} from '../src/components/Navbar.js' ;
import {Banner} from '../src/components/Banner.js';
import {Experience} from '../src/components/Experience.js';
import {Footer} from '../src/components/Footer.js';
import {Publications} from '../src/components/Publications.js';
import {Presentations} from '../src/components/Presentations.js';
import {Skills} from '../src/components/Skills.js';
import {Education} from '../src/components/Education.js';
import React from 'react';
function App() {

  return (
    <div className="App">
      <NavBar/>
      <Banner />
      <Experience/>
      <Publications/>
      <Presentations/>
      <Skills/>
      <Education/>
      <Footer/>
    </div>
  );
}

export default App;
